import { defineComponent, ref, computed, watch, onMounted, openBlock, createElementBlock, normalizeClass, createElementVNode, createBlock, unref, normalizeProps, mergeProps, createCommentVNode, Fragment, renderList, normalizeStyle, createVNode, withCtx, Teleport } from "vue";
import { CdrAccordionGroup, CdrAccordion, CdrRating } from "@rei/cedar";
import BikeMeasurements from "../BikeMeasurements/BikeMeasurements.mjs";
import ExpertAdvice from "../ExpertAdvice/ExpertAdvice.mjs";
import FeaturedSpecs from "../FeaturedSpecs/FeaturedSpecs.mjs";
import GenericSizeChart from "../GenericSizeChart/GenericSizeChart.mjs";
import GenericMedia from "../GenericMedia/GenericMedia.mjs";
import MemberBenefits from "../MemberBenefits/MemberBenefits.mjs";
import _sfc_main$1 from "../MembershipBillboard/MembershipBillboard.mjs";
/* empty css                                           */
import ProductFeatures from "../ProductFeatures/ProductFeatures.mjs";
import ProductManuals from "../ProductManuals/ProductManuals.mjs";
import RelatedLinks from "../RelatedLinks/RelatedLinks.mjs";
import TechnicalSpecs from "../TechnicalSpecs/TechnicalSpecs.mjs";
import SleepingBagSizeChart from "../SleepingBagSizeChart/SleepingBagSizeChart.mjs";
import ProductStorytelling from "../ProductStorytelling/ProductStorytelling.mjs";
import RrRecs from "../RrRecs/RrRecs.mjs";
import CuratedOutfit from "../CuratedOutfit/CuratedOutfit.mjs";
import _sfc_main$2 from "../VisibilityTracker/VisibilityTracker.mjs";
import CoopBrandAsset from "../CoopBrandAsset/CoopBrandAsset.mjs";
import ProductReviews from "../ProductReviews/ProductReviews.mjs";
import { ExpertiseChatV2, ExpertiseChatV1 } from "../ExpertiseChat/index.mjs";
import { CoopBrandAssetType } from "../CoopBrandAsset/CoopBrandAsset2.mjs";
const _hoisted_1 = {
  class: "below-the-fold__sentinel-wrapper"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "below-the-fold__location-image-button-container"
};
const _hoisted_5 = ["aria-current", "aria-label", "onClick"];
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
  key: 0,
  class: "below-the-fold__sleeping-bag-size-chart-container"
};
const _hoisted_8 = {
  key: 5,
  id: "buying-advice",
  class: "below-the-fold__buying-advice"
};
const _hoisted_9 = {
  key: 0,
  class: "below-the-fold__header__container"
};
const _hoisted_10 = {
  class: "below-the-fold__buying-advice-container"
};
const _hoisted_11 = {
  key: 6,
  class: "below-the-fold__coop-brand-asset-container"
};
const _hoisted_12 = {
  id: "reviews-scroll-anchor",
  class: "below-the-fold__header"
};
const _hoisted_13 = ["data-bv-product-id"];
const _hoisted_14 = ["data-bv-product-id"];
const _hoisted_15 = {
  key: 3,
  ref: "klugeBoxMobile",
  class: "below-the-fold__recs-mobile"
};
const _hoisted_16 = {
  ref: "recsStuff"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BelowTheFold",
  props: {
    accordionStatus: {},
    bikeDiagram: {},
    description: {},
    expertAdvice: {
      default: void 0
    },
    featuredSpecs: {
      default: void 0
    },
    isBike: {
      type: Boolean
    },
    isJustForMembers: {
      type: Boolean
    },
    locationImages: {
      default: void 0
    },
    memberBenefitsList: {
      default: void 0
    },
    membershipBillboardProps: {
      default: void 0
    },
    primaryRecs: {
      default: void 0
    },
    productFeatureProps: {},
    productReviewsProps: {},
    recsComponent: {
      default: void 0
    },
    relatedLinks: {
      default: void 0
    },
    relatedRecs: {
      default: void 0
    },
    reviewSummary: {
      default: void 0
    },
    showBuyingAdvice: {
      type: Boolean
    },
    showNativeReviews: {
      type: Boolean,
      default: false
    },
    showProductStorytelling: {
      type: Boolean
    },
    showSleepingBagSizeChart: {
      type: Boolean
    },
    sizeChart: {
      default: void 0
    },
    storytellingProps: {
      default: void 0
    },
    styleId: {},
    techSpecs: {},
    userManuals: {
      default: void 0
    },
    videoLinkName: {
      default: void 0
    },
    curatedOutfit: {
      default: () => ({
        styles: [],
        data: {
          headingTop: "",
          headingBottom: "",
          authors: []
        }
      })
    },
    showExpertiseTestVariant1: {
      type: Boolean,
      default: false
    },
    showExpertiseTestVariant2: {
      type: Boolean,
      default: false
    },
    isInGladlyTest: {
      type: Boolean,
      default: false
    },
    showXlBreakpoint: {
      type: Boolean,
      default: false
    },
    showQASection: {
      type: Boolean
    },
    isInQATest: {
      type: Boolean
    },
    showCoopBrandAsset: {
      type: Boolean
    },
    coopBrandAssetType: {
      default: CoopBrandAssetType.None
    }
  },
  emits: [
    "acquisitionDetailsClick",
    "accordionToggle",
    "addMembershipToCart",
    "bvContainerMounted",
    "metricsClick",
    "modalOpen",
    "recsClick",
    "setAccordionVisible",
    "initGladlyChat",
    // TODO: cleanup PDX-5603
    "callGladlyChat",
    // TODO: cleanup PDX-5603
    "reviewStarClick",
    "productRatingFilterClick",
    "individualReviewFeedbackClick",
    "productReviewsSort",
    "productReviewsStarsChanged",
    "productReviewsPagination"
  ],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const observer = ref(null);
    const locationImagesObserver = ref(null);
    const sentinelObserver = ref(null);
    const disableTeleport = ref(false);
    const locationImageIndex = ref(0);
    const prerenderWrapper = ref(null);
    const btfRoot = ref(null);
    const btfSentinel = ref(null);
    const klugeBoxDesktop = ref(null);
    const locationImagesMobile = ref(null);
    const locationImagesDesktop = ref(null);
    const lazyOpts = {
      intersectionRatio: 1e-3,
      threshold: [0.25, 0.5, 0.75, 1]
    };
    const heroLocationImage = computed(() => {
      var _a;
      return (_a = props == null ? void 0 : props.locationImages) == null ? void 0 : _a[locationImageIndex.value];
    });
    watch(() => props.locationImages, () => {
      locationImageIndex.value = 0;
    });
    const observerCB = (entries) => {
      entries.forEach((entry) => {
        const isDesktop = entry.intersectionRatio > 0;
        disableTeleport.value = !isDesktop;
        emit("setAccordionVisible", !isDesktop);
      });
    };
    const locationObserverCB = (entries) => {
      entries.forEach((entry) => {
        var _a;
        if (entry.intersectionRatio >= 0.2) {
          emit("metricsClick", {
            linkName: "location image view"
          });
          (_a = locationImagesObserver.value) == null ? void 0 : _a.disconnect();
        }
      });
    };
    const sentinelCB = (entries) => {
      entries.forEach((entry) => {
        var _a;
        if (entry.intersectionRatio >= 0.5) {
          emit("metricsClick", {
            linkName: "scroll below description"
          });
          (_a = sentinelObserver.value) == null ? void 0 : _a.disconnect();
        }
      });
    };
    const handleToggle = (section) => {
      emit("accordionToggle", section);
      const linkName = props.accordionStatus[section] ? `expand-${section}` : `collapse-${section}`;
      emit("metricsClick", {
        linkName
      });
    };
    const handleLocationThumbnailClick = (index) => {
      locationImageIndex.value = index;
      emit("metricsClick", {
        linkName: "location image thumbnail click"
      });
    };
    onMounted(() => {
      var _a;
      emit("bvContainerMounted", prerenderWrapper.value);
      observer.value = new window.IntersectionObserver(observerCB, {
        root: btfRoot.value
      });
      if (klugeBoxDesktop.value) observer.value.observe(klugeBoxDesktop.value);
      if ((_a = props.locationImages) == null ? void 0 : _a.length) {
        locationImagesObserver.value = new window.IntersectionObserver(locationObserverCB, {
          threshold: [0, 0.2, 0.5, 0.75, 1]
        });
        if (locationImagesMobile.value) {
          locationImagesObserver.value.observe(locationImagesMobile.value);
        }
        if (locationImagesDesktop.value) {
          locationImagesObserver.value.observe(locationImagesDesktop.value);
        }
      }
      sentinelObserver.value = new window.IntersectionObserver(sentinelCB, {
        threshold: [0.25, 0.5, 0.75]
      });
      if (btfSentinel.value) sentinelObserver.value.observe(btfSentinel.value);
    });
    return (_ctx, _cache) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
      return openBlock(), createElementBlock("div", {
        ref_key: "btfRoot",
        ref: btfRoot,
        class: normalizeClass(["below-the-fold", {
          "below-the-fold--xl": _ctx.showXlBreakpoint
        }])
      }, [createElementVNode("div", {
        class: normalizeClass({
          "below-the-fold__product-storytelling-wrapper": _ctx.showProductStorytelling
        })
      }, [_ctx.showProductStorytelling && _ctx.storytellingProps ? (openBlock(), createBlock(unref(ProductStorytelling), normalizeProps(mergeProps({
        key: 0
      }, _ctx.storytellingProps)), null, 16)) : createCommentVNode("", true)], 2), ((_a = _ctx.featuredSpecs) == null ? void 0 : _a.length) && !_ctx.showProductStorytelling ? (openBlock(), createBlock(unref(FeaturedSpecs), {
        key: 0,
        "featured-specs": _ctx.featuredSpecs,
        "is-just-for-members": _ctx.isJustForMembers,
        "show-xl-breakpoint": _ctx.showXlBreakpoint,
        class: "below-the-fold__featured-specs"
      }, null, 8, ["featured-specs", "is-just-for-members", "show-xl-breakpoint"])) : createCommentVNode("", true), _ctx.membershipBillboardProps.showAnyBillboard ? (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({
        key: 1
      }, _ctx.membershipBillboardProps, {
        onAcquisitionDetailsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("modalOpen", data)),
        onAddMembershipToCart: _cache[1] || (_cache[1] = (data) => _ctx.$emit("addMembershipToCart", data)),
        onMetricsClick: _cache[2] || (_cache[2] = (data) => _ctx.$emit("metricsClick", data)),
        onRetentionDetailsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("modalOpen", data))
      }), null, 16)) : createCommentVNode("", true), createElementVNode("div", _hoisted_1, [createElementVNode("div", {
        ref_key: "btfSentinel",
        ref: btfSentinel,
        class: "below-the-fold__sentinel"
      }, null, 512)]), ((_b = _ctx.locationImages) == null ? void 0 : _b.length) ? (openBlock(), createElementBlock(Fragment, {
        key: 2
      }, [createElementVNode("div", {
        ref_key: "locationImagesMobile",
        ref: locationImagesMobile,
        class: "below-the-fold__location-images--mobile",
        "data-ui": "location-images"
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList((_c = _ctx.locationImages) == null ? void 0 : _c.slice(0, 3), (image) => {
        return openBlock(), createElementBlock("img", {
          key: image.uri,
          src: image.uri,
          alt: image.altText,
          loading: "lazy",
          class: "below-the-fold__location-image",
          style: normalizeStyle(`aspect-ratio: ${image.maxWidth} / ${image.maxHeight}`)
        }, null, 12, _hoisted_2);
      }), 128))], 512), createElementVNode("div", {
        ref_key: "locationImagesDesktop",
        ref: locationImagesDesktop,
        class: "below-the-fold__location-images--desktop",
        "data-ui": "location-images"
      }, [createElementVNode("img", {
        src: (_d = heroLocationImage.value) == null ? void 0 : _d.uri,
        alt: (_e = heroLocationImage.value) == null ? void 0 : _e.altText,
        loading: "lazy",
        class: "below-the-fold__location-image-hero",
        style: normalizeStyle(`aspect-ratio: ${(_f = heroLocationImage.value) == null ? void 0 : _f.maxWidth} / ${(_g = heroLocationImage.value) == null ? void 0 : _g.maxHeight}`)
      }, null, 12, _hoisted_3), createElementVNode("div", _hoisted_4, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.locationImages.slice(0, 9), (image, index) => {
        return openBlock(), createElementBlock("button", {
          key: image.thumbnailUri,
          class: normalizeClass(["below-the-fold__location-image-button", {
            "below-the-fold__location-image-button--active": index === locationImageIndex.value
          }]),
          "aria-current": index === locationImageIndex.value,
          "aria-label": `Load ${image.altText} - Image ${index + 1} of ${_ctx.locationImages.length}`,
          onClick: () => handleLocationThumbnailClick(index)
        }, [createElementVNode("img", {
          src: image.thumbnailUri,
          alt: image.altText,
          loading: "lazy",
          class: "below-the-fold__location-image-thumb"
        }, null, 8, _hoisted_6)], 10, _hoisted_5);
      }), 128))])], 512)], 64)) : createCommentVNode("", true), createVNode(unref(CdrAccordionGroup), {
        class: normalizeClass(["below-the-fold__accordion below-the-fold__section", {
          "below-the-fold__accordion--curated": (_i = (_h = _ctx.curatedOutfit) == null ? void 0 : _h.styles) == null ? void 0 : _i.length
        }]),
        unwrap: "@md @lg"
      }, {
        default: withCtx(() => {
          var _a2, _b2, _c2, _d2;
          return [((_b2 = (_a2 = _ctx.curatedOutfit) == null ? void 0 : _a2.styles) == null ? void 0 : _b2.length) ? (openBlock(), createBlock(unref(CuratedOutfit), {
            key: 0,
            styles: _ctx.curatedOutfit.styles,
            data: _ctx.curatedOutfit.data,
            onMetricsClick: _cache[4] || (_cache[4] = (data) => _ctx.$emit("metricsClick", data))
          }, null, 8, ["styles", "data"])) : createCommentVNode("", true), createVNode(unref(CdrAccordion), {
            id: "features",
            "data-ui": "product-features",
            opened: _ctx.accordionStatus.features,
            level: "2",
            onAccordionToggle: _cache[7] || (_cache[7] = () => handleToggle("features"))
          }, {
            label: withCtx(() => _cache[40] || (_cache[40] = [createElementVNode("span", {
              class: "below-the-fold__header"
            }, " Features ", -1)])),
            default: withCtx(() => [createVNode(unref(ProductFeatures), mergeProps(_ctx.productFeatureProps, {
              onMetricsClick: _cache[5] || (_cache[5] = (data) => _ctx.$emit("metricsClick", data)),
              onModalOpen: _cache[6] || (_cache[6] = (modalProps) => _ctx.$emit("modalOpen", modalProps))
            }), null, 16)]),
            _: 1
          }, 8, ["opened"]), createVNode(unref(CdrAccordion), {
            id: "tech-specs",
            class: "below-the-fold__tech-specs-accordion",
            "data-ui": "tech-specs",
            opened: _ctx.accordionStatus.specs,
            level: "2",
            onAccordionToggle: _cache[12] || (_cache[12] = () => handleToggle("specs"))
          }, {
            label: withCtx(() => [_cache[41] || (_cache[41] = createElementVNode("span", {
              class: "below-the-fold__header"
            }, " Technical Specs ", -1)), _ctx.isInGladlyTest ? (openBlock(), createBlock(unref(_sfc_main$2), {
              key: 0,
              "link-name": "SCSGreenVestConnect_SizeScroll",
              onMetricsClick: _cache[8] || (_cache[8] = (data) => _ctx.$emit("metricsClick", data))
            })) : createCommentVNode("", true), _ctx.showExpertiseTestVariant2 ? (openBlock(), createBlock(unref(ExpertiseChatV2), {
              key: 1,
              onMetricsClick: _cache[9] || (_cache[9] = (data) => _ctx.$emit("metricsClick", data)),
              onInitGladlyChat: _cache[10] || (_cache[10] = () => _ctx.$emit("initGladlyChat")),
              onCallGladlyChat: _cache[11] || (_cache[11] = () => _ctx.$emit("callGladlyChat"))
            })) : createCommentVNode("", true)]),
            default: withCtx(() => [createVNode(unref(TechnicalSpecs), {
              "tech-specs": _ctx.techSpecs
            }, null, 8, ["tech-specs"])]),
            _: 1
          }, 8, ["opened"]), ((_c2 = _ctx.userManuals) == null ? void 0 : _c2.length) ? (openBlock(), createBlock(unref(CdrAccordion), {
            key: 1,
            id: "product-user-manuals",
            "data-ui": "product-user-manuals",
            opened: _ctx.accordionStatus.userManuals,
            level: "2",
            onAccordionToggle: _cache[14] || (_cache[14] = () => handleToggle("userManuals"))
          }, {
            label: withCtx(() => _cache[42] || (_cache[42] = [createElementVNode("span", {
              class: "below-the-fold__header"
            }, "Additional Information", -1)])),
            default: withCtx(() => [createVNode(unref(ProductManuals), {
              "user-manuals": _ctx.userManuals,
              onMetricsClick: _cache[13] || (_cache[13] = (data) => _ctx.$emit("metricsClick", data))
            }, null, 8, ["user-manuals"])]),
            _: 1
          }, 8, ["opened"])) : createCommentVNode("", true), _ctx.sizeChart ? (openBlock(), createBlock(unref(CdrAccordion), {
            key: 2,
            id: "size-chart",
            "data-ui": "size-chart",
            opened: _ctx.accordionStatus.sizeChart,
            "content-spacing": false,
            level: "2",
            onAccordionToggle: _cache[15] || (_cache[15] = () => handleToggle("sizeChart"))
          }, {
            label: withCtx(() => _cache[43] || (_cache[43] = [createElementVNode("span", {
              class: "below-the-fold__header"
            }, "Size Chart", -1)])),
            default: withCtx(() => [_ctx.showSleepingBagSizeChart ? (openBlock(), createElementBlock("div", _hoisted_7, [createVNode(unref(SleepingBagSizeChart), {
              "table-data": _ctx.sizeChart,
              class: "below-the-fold__sleeping-bag-size-chart"
            }, null, 8, ["table-data"]), createVNode(unref(GenericMedia), {
              class: "below-the-fold__sleeping-bag-diagram",
              "aria-hidden": "true",
              "image-src": "https://satchel.rei.com/media/product/sleeping-bag-chart-diagram-03.jpg",
              lazy: true,
              "lazy-opts": lazyOpts,
              title: "sleeping bag measuring diagram"
            })])) : (openBlock(), createElementBlock(Fragment, {
              key: 1
            }, [createVNode(unref(GenericSizeChart), {
              "table-data": _ctx.sizeChart
            }, null, 8, ["table-data"]), _ctx.isBike ? (openBlock(), createBlock(unref(BikeMeasurements), {
              key: 0,
              "bike-diagram": _ctx.bikeDiagram
            }, null, 8, ["bike-diagram"])) : createCommentVNode("", true)], 64))]),
            _: 1
          }, 8, ["opened"])) : createCommentVNode("", true), _ctx.isInGladlyTest ? (openBlock(), createBlock(unref(_sfc_main$2), {
            key: 3,
            "link-name": "SCSGreenVestConnect_SpecScroll",
            onMetricsClick: _cache[16] || (_cache[16] = (data) => _ctx.$emit("metricsClick", data))
          })) : createCommentVNode("", true), _ctx.showExpertiseTestVariant1 ? (openBlock(), createBlock(unref(ExpertiseChatV1), {
            key: 4,
            onMetricsClick: _cache[17] || (_cache[17] = (data) => _ctx.$emit("metricsClick", data)),
            onInitGladly: _cache[18] || (_cache[18] = () => _ctx.$emit("initGladlyChat")),
            onCtaClicked: _cache[19] || (_cache[19] = () => _ctx.$emit("callGladlyChat"))
          })) : createCommentVNode("", true), _ctx.showBuyingAdvice && _ctx.expertAdvice ? (openBlock(), createElementBlock("div", _hoisted_8, [!_ctx.showExpertiseTestVariant1 ? (openBlock(), createElementBlock("div", _hoisted_9, _cache[44] || (_cache[44] = [createElementVNode("h2", {
            class: "below-the-fold__header"
          }, " Buying Advice ", -1)]))) : createCommentVNode("", true), createElementVNode("div", _hoisted_10, [createVNode(unref(ExpertAdvice), mergeProps(_ctx.expertAdvice, {
            "style-id": _ctx.styleId,
            "show-xl-breakpoint": _ctx.showXlBreakpoint,
            onMetricsClick: _cache[20] || (_cache[20] = (data) => _ctx.$emit("metricsClick", data))
          }), null, 16, ["style-id", "show-xl-breakpoint"])])])) : createCommentVNode("", true), _ctx.showCoopBrandAsset ? (openBlock(), createElementBlock("div", _hoisted_11, [createVNode(unref(CoopBrandAsset), {
            asset: _ctx.coopBrandAssetType,
            onMetricsClick: _cache[21] || (_cache[21] = (data) => _ctx.$emit("metricsClick", data))
          }, null, 8, ["asset"])])) : createCommentVNode("", true), _ctx.isJustForMembers && ((_d2 = _ctx.memberBenefitsList) == null ? void 0 : _d2.renderSection) ? (openBlock(), createBlock(unref(CdrAccordion), {
            key: 7,
            id: "member-benefits",
            "content-spacing": false,
            "data-ui": "member-benefits",
            opened: _ctx.accordionStatus.membership,
            level: "2",
            onAccordionToggle: _cache[24] || (_cache[24] = () => handleToggle("membership"))
          }, {
            label: withCtx(() => _cache[45] || (_cache[45] = [createElementVNode("span", {
              class: "below-the-fold__header"
            }, "REI Co-op Membership", -1)])),
            default: withCtx(() => [createVNode(unref(MemberBenefits), mergeProps(_ctx.memberBenefitsList, {
              onAddMembershipToCart: _cache[22] || (_cache[22] = (data) => _ctx.$emit("addMembershipToCart", data)),
              onMetricsClick: _cache[23] || (_cache[23] = (data) => _ctx.$emit("metricsClick", data))
            }), null, 16)]),
            _: 1
          }, 8, ["opened"])) : createCommentVNode("", true), createElementVNode("div", {
            id: "recsDesktop",
            ref_key: "klugeBoxDesktop",
            ref: klugeBoxDesktop,
            class: "below-the-fold__kluge-box"
          }, null, 512), createVNode(unref(CdrAccordion), {
            id: "product-reviews",
            "data-ui": "product-reviews",
            opened: _ctx.accordionStatus.reviews,
            level: "2",
            onAccordionToggle: _cache[33] || (_cache[33] = () => handleToggle("reviews"))
          }, {
            label: withCtx(() => {
              var _a3, _b3;
              return [createElementVNode("span", _hoisted_12, [_cache[46] || (_cache[46] = createElementVNode("span", {
                class: "below-the-fold__label-text"
              }, "Reviews", -1)), createVNode(unref(CdrRating), {
                class: "below-the-fold__review-summary",
                "data-ui": "review-summary",
                size: "small",
                rating: (_a3 = _ctx.reviewSummary) == null ? void 0 : _a3.averageRating,
                count: (_b3 = _ctx.reviewSummary) == null ? void 0 : _b3.count,
                compact: ""
              }, null, 8, ["rating", "count"])])];
            }),
            default: withCtx(() => [!_ctx.showNativeReviews || !_ctx.productReviewsProps ? (openBlock(), createElementBlock("section", {
              key: 0,
              id: "bv-product-reviews",
              ref_key: "prerenderWrapper",
              ref: prerenderWrapper,
              "aria-labelledby": "product-reviews-label",
              class: "bv2-review-container",
              "data-bv-show": "reviews",
              "data-bv-product-id": _ctx.styleId
            }, " Loading Reviews... ", 8, _hoisted_13)) : (openBlock(), createBlock(unref(ProductReviews), mergeProps({
              key: 1,
              ref_key: "prerenderWrapper",
              ref: prerenderWrapper
            }, _ctx.productReviewsProps, {
              "show-xl-breakpoint": _ctx.showXlBreakpoint,
              onMetricsClick: _cache[25] || (_cache[25] = (data) => emit("metricsClick", data)),
              onReviewStarClick: _cache[26] || (_cache[26] = (rating) => emit("reviewStarClick", rating)),
              onProductReviewsStarsChanged: _cache[27] || (_cache[27] = (payload) => emit("productReviewsStarsChanged", payload)),
              onProductRatingFilterClick: _cache[28] || (_cache[28] = (rating) => emit("productRatingFilterClick", rating)),
              onIndividualReviewFeedbackClick: _cache[29] || (_cache[29] = (data) => emit("individualReviewFeedbackClick", data)),
              onModalOpen: _cache[30] || (_cache[30] = (data) => emit("modalOpen", data)),
              onProductReviewsSort: _cache[31] || (_cache[31] = (payload) => {
                emit("productReviewsSort", payload);
              }),
              onProductReviewsPagination: _cache[32] || (_cache[32] = (payload) => {
                emit("productReviewsPagination", payload);
              })
            }), null, 16, ["show-xl-breakpoint"]))]),
            _: 1
          }, 8, ["opened"]), _ctx.isInQATest ? (openBlock(), createBlock(unref(_sfc_main$2), {
            key: 8,
            "link-name": "q&a impression",
            onMetricsClick: _cache[34] || (_cache[34] = (data) => _ctx.$emit("metricsClick", data))
          })) : createCommentVNode("", true), _ctx.showQASection ? (openBlock(), createBlock(unref(CdrAccordion), {
            key: 9,
            id: "product-questions",
            "data-ui": "product-questions",
            opened: _ctx.accordionStatus.questions,
            level: "2",
            onAccordionToggle: _cache[35] || (_cache[35] = () => handleToggle("questions"))
          }, {
            label: withCtx(() => _cache[47] || (_cache[47] = [createElementVNode("span", {
              class: "below-the-fold__header"
            }, " Questions & Answers ", -1)])),
            default: withCtx(() => [createElementVNode("section", {
              ref: "bvQuestions",
              "aria-labelledby": "product-questions-label",
              class: "bv2-questions-container",
              "data-bv-show": "questions",
              "data-bv-product-id": _ctx.styleId
            }, " Loading Questions... ", 8, _hoisted_14)]),
            _: 1
          }, 8, ["opened"])) : createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"]), !!_ctx.recsComponent ? (openBlock(), createElementBlock("div", _hoisted_15, [(openBlock(), createBlock(Teleport, {
        to: "#recsDesktop",
        disabled: disableTeleport.value
      }, [createElementVNode("div", _hoisted_16, [createVNode(unref(RrRecs), {
        ref: "primaryRecs",
        "header-id": "primary-recs-header",
        "img-size": 300,
        message: (_j = _ctx.primaryRecs) == null ? void 0 : _j.message,
        recs: _ctx.primaryRecs,
        "recs-component": _ctx.recsComponent,
        "recs-id": "primary-recs",
        "show-loading-recs": !((_k = _ctx.primaryRecs) == null ? void 0 : _k.items) && !!_ctx.recsComponent,
        onRecsClick: _cache[36] || (_cache[36] = (data) => _ctx.$emit("recsClick", data)),
        onRecsVisible: _cache[37] || (_cache[37] = () => _ctx.$emit("metricsClick", {
          linkName: "algonomy_view"
        }))
      }, null, 8, ["message", "recs", "recs-component", "show-loading-recs"]), createVNode(unref(RrRecs), {
        ref: "relatedRecs",
        "header-id": "related-recs-header",
        "img-size": 300,
        message: (_l = _ctx.relatedRecs) == null ? void 0 : _l.message,
        recs: _ctx.relatedRecs,
        "recs-component": _ctx.recsComponent,
        "recs-id": "related-recs",
        "show-loading-recs": !((_m = _ctx.relatedRecs) == null ? void 0 : _m.items) && !!_ctx.recsComponent,
        onRecsClick: _cache[38] || (_cache[38] = (data) => _ctx.$emit("recsClick", data))
      }, null, 8, ["message", "recs", "recs-component", "show-loading-recs"])], 512)], 8, ["disabled"]))], 512)) : createCommentVNode("", true), ((_n = _ctx.relatedLinks) == null ? void 0 : _n.length) ? (openBlock(), createBlock(unref(RelatedLinks), {
        key: 4,
        heading: "Related Categories",
        links: _ctx.relatedLinks,
        onMetricsClick: _cache[39] || (_cache[39] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["links"])) : createCommentVNode("", true)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BelowTheFold2.mjs.map
